module.exports = __webpack_public_path__ + "img/icon_map_51_off_001.bb7b16bd.png";